// DatenschutzPage: Privacy policy page (DSGVO Art. 13/14) — publicly accessible without login.
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './LegalPage.css';

export default function DatenschutzPage() {
  const navigate = useNavigate();

  const contactName = process.env.REACT_APP_CONTACT_NAME || '[DEIN VOLLSTÄNDIGER NAME]';
  const contactName2 = process.env.REACT_APP_CONTACT_NAME2 || '[ZWEITER NAME ODER FIRMA]';
  const contactStreet = process.env.REACT_APP_CONTACT_STREET || '[STRASSE UND HAUSNUMMER]';
  const contactCity = process.env.REACT_APP_CONTACT_CITY || '[PLZ ORT]';
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || '[DEINE-EMAIL@EXAMPLE.DE]';

  return (
    <div className="legal-page">
      <div className="legal-page__content">
        <button
          className="legal-page__back"
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <ArrowLeft size={16} /> Zurück
        </button>

        <h1>Datenschutzerklärung</h1>
        <p className="legal-page__updated">Stand: März 2026</p>

        {/* ─── 1. Verantwortlicher ──────────────────────────── */}
        <h2>1. Verantwortlicher</h2>
        <address className="legal-page__address">
          <strong>{contactName}</strong><br />
          {contactName2}<br />
          {contactStreet}<br />
          {contactCity}<br />
          E-Mail: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
        </address>

        {/* ─── 2. Überblick ──────────────────────────────────── */}
        <h2>2. Überblick der Verarbeitung</h2>
        <p>
          Diese Website ist eine nicht-kommerzielle Webanwendung zur Verwaltung von
          Magic: The Gathering-Kartensammlungen. Bei der Nutzung werden
          personenbezogene Daten verarbeitet, um die Funktionalität bereitstellen zu
          können.
        </p>

        {/* ─── 3. Arten der verarbeiteten Daten ──────────────── */}
        <h2>3. Arten der verarbeiteten Daten</h2>
        <ul>
          <li><strong>Bestandsdaten:</strong> E-Mail-Adresse, Anzeigename</li>
          <li><strong>Authentifizierungsdaten:</strong> Passwort (verschlüsselt gespeichert mit bcrypt), JSON Web Token (JWT)</li>
          <li><strong>Nutzungsdaten:</strong> Zeitpunkt der letzten Anmeldung</li>
          <li><strong>Protokolldaten:</strong> IP-Adressen werden ausschließlich im Rahmen administrativer Aktionen protokolliert (Admin-Audit-Log)</li>
          <li><strong>Einstellungen:</strong> Bevorzugte Kartensprache, UI-Sprache, Darstellungsmodus (Theme), Deck-Editor-Einstellungen</li>
          <li><strong>Standortdaten:</strong> Postleitzahl und daraus abgeleitete Geokoordinaten (freiwillig, nur bei aktiver Nutzung der standortbasierten Spielersuche)</li>
          <li><strong>Google OAuth-Tokens:</strong> Zugriffstoken und Aktualisierungstoken für Google Drive (nur bei Verknüpfung mit Google Drive)</li>
        </ul>

        {/* ─── 4. Rechtsgrundlagen ─────────────────────────── */}
        <h2>4. Rechtsgrundlagen der Verarbeitung</h2>
        <ul>
          <li>
            <strong>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung):</strong>{' '}
            Verarbeitung von E-Mail, Passwort und Anzeigename zur Bereitstellung
            des Benutzerkontos und der Anwendungsfunktionen.
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung):</strong>{' '}
            Verknüpfung mit Google Drive erfolgt nur durch ausdrückliche
            Einwilligung über den Google OAuth Consent Screen. Die Verarbeitung
            von Standortdaten (PLZ) für die standortbasierte Spielersuche
            erfolgt ebenfalls nur mit Ihrer ausdrücklichen Einwilligung (Opt-in).
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. f DSGVO (Berechtigtes Interesse):</strong>{' '}
            Protokollierung von IP-Adressen bei administrativen Aktionen zur
            Gewährleistung der Sicherheit des Dienstes.
          </li>
        </ul>

        {/* ─── 5. Hosting ─────────────────────────────────── */}
        <h2>5. Hosting</h2>
        <p>
          Diese Website wird bei einem professionellen Hosting-Anbieter mit Serverstandort
          Deutschland betrieben. Der Hosting-Dienstleister verarbeitet personenbezogene Daten
          ausschließlich im Rahmen einer Vereinbarung zur Auftragsverarbeitung (Art. 28 DSGVO) 
          und nach Weisung des Verantwortlichen.
          Die Daten werden vertraulich behandelt und nicht an Dritte weitergegeben.
        </p>

        {/* ─── 6. SSL-Verschlüsselung ────────────────────── */}
        <h2>6. SSL-Verschlüsselung</h2>
        <p>
          Diese Website nutzt aus Sicherheitsgründen eine SSL/TLS-Verschlüsselung.
          Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
          des Browsers von „http://" auf „https://" wechselt. Wenn die SSL-
          Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
          übermitteln, nicht von Dritten mitgelesen werden.
        </p>

        {/* ─── 7. Benutzerkonto ──────────────────────────── */}
        <h2>7. Benutzerkonto und Anmeldung</h2>
        <p>
          Zur Nutzung der Anwendung ist die Erstellung eines Benutzerkontos mit
          E-Mail-Adresse, Anzeigename und Passwort erforderlich. Ihr Passwort wird
          sicher verschlüsselt gespeichert und ist für niemanden einsehbar. Die
          Daten werden ausschließlich zur Bereitstellung der Funktionen dieser
          Anwendung verwendet und nicht an Dritte weitergegeben.
        </p>

        {/* ─── 8. localStorage ─────────────────────────────── */}
        <h2>8. Verwendung von localStorage</h2>
        <p>
          Diese Website verwendet den localStorage Ihres Browsers zur Speicherung
          technisch notwendiger Daten. Es werden <strong>keine Cookies</strong>{' '}
          gesetzt.
        </p>
        <p>Im localStorage werden folgende Daten gespeichert:</p>
        <ul>
          <li><strong>authToken:</strong> JWT-Token zur Authentifizierung (enthält Benutzer-ID, E-Mail)</li>
          <li><strong>user:</strong> Benutzerinformationen (ID, E-Mail, Anzeigename)</li>
          <li><strong>theme:</strong> Gewähltes Darstellungsdesign (hell/dunkel/system)</li>
          <li><strong>mobileAddTab:</strong> Zuletzt gewählter Reiter im mobilen Hinzufügen-Modus (Suche/Vorschläge)</li>
        </ul>
        <p>
          Die Speicherung erfolgt auf Grundlage von § 25 Abs. 2 TTDSG, da sie für
          die Bereitstellung des vom Nutzer ausdrücklich gewünschten Dienstes
          unbedingt erforderlich ist.
        </p>

        {/* ─── 9. Google Drive ──────────────────────────────── */}
        <h2>9. Google Drive-Integration</h2>
        <p>
          Optional können Sie Ihren Account mit Google Drive verknüpfen, um
          CSV-Sammlungsdateien direkt aus Google Drive zu importieren. Dies
          erfordert Ihre ausdrückliche Einwilligung über den Google OAuth Consent
          Screen.
        </p>
        <p>Dabei werden folgende Daten verarbeitet:</p>
        <ul>
          <li>Google OAuth Access-Token und Refresh-Token (verschlüsselt in unserer Datenbank gespeichert)</li>
          <li>Zugriff auf Google Drive erfolgt ausschließlich im Modus <em>drive.readonly</em> (nur Lesezugriff)</li>
          <li>Es werden nur die von Ihnen angegebenen CSV-Dateien abgerufen — keine weiteren Dateien, Kontakte oder Profilinformationen</li>
        </ul>
        <p>
          Sie können die Verknüpfung jederzeit in den{' '}
          <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">
            Google-Kontoeinstellungen
          </a>{' '}
          widerrufen.
        </p>
        <p>
          Datenschutzerklärung von Google:{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            https://policies.google.com/privacy
          </a>
        </p>

        {/* ─── 10. Standortbasierte Spielersuche ──────────── */}
        <h2>10. Standortbasierte Spielersuche</h2>
        <p>
          Sie können freiwillig Ihre Postleitzahl (PLZ) hinterlegen, um andere
          Spieler in Ihrer Umgebung zu finden. Dies ist ein optionales Feature
          und erfordert Ihre aktive Eingabe (Opt-in).
        </p>
        <p>Dabei werden folgende Daten verarbeitet:</p>
        <ul>
          <li>Ihre Postleitzahl (5-stellig, deutsch)</li>
          <li>Daraus berechnete geografische Koordinaten (Breiten- und Längengrad auf PLZ-Ebene)</li>
        </ul>
        <p>
          <strong>Sichtbarkeit:</strong> Über zwei separate Einstellungen steuern
          Sie, ob (1) Sie in der Spielersuche für andere Nutzer sichtbar sind und
          (2) ob Ihre Kartensammlung für Nicht-Freunde einsehbar ist. Beide
          Einstellungen sind standardmäßig deaktiviert.
        </p>
        <p>
          <strong>Datenschutz-by-Design:</strong> Anderen Nutzern wird niemals
          Ihre exakte PLZ angezeigt — nur die ungefähre Entfernung (auf ganze
          Kilometer gerundet). Die Berechnung der Entfernung erfolgt
          ausschließlich auf unserem Server.
        </p>
        <p>
          Sie können Ihre PLZ und die zugehörigen Koordinaten jederzeit löschen.
          Dabei werden automatisch auch beide Sichtbarkeits-Einstellungen
          deaktiviert. Die Standortdaten werden ausschließlich in unserer eigenen
          Datenbank gespeichert und nicht an Dritte übermittelt.
        </p>

        {/* ─── 11. Scryfall ─────────────────────────────────── */}
        <h2>11. Scryfall API und Kartendaten</h2>
        <p>
          Diese Anwendung nutzt die öffentliche API von{' '}
          <a href="https://scryfall.com" target="_blank" rel="noopener noreferrer">Scryfall</a>{' '}
          zum Abruf von Kartendaten und -bildern für Magic: The Gathering.
        </p>
        <p>
          Kartendaten ruft der Server der Anwendung bei Scryfall (api.scryfall.com) ab. Die
          Kartenbilder lädt Ihr Browser direkt von den Servern von Scryfall (cards.scryfall.io);
          dabei kann Ihre IP-Adresse an Scryfall übermittelt werden. Scryfall hat seinen Sitz in den USA.
        </p>
        <p>
          Scryfall erhebt keine personenbezogenen Daten über ihre API. Es werden
          keine API-Schlüssel oder Benutzer-Identifikatoren an Scryfall übermittelt.
        </p>

        {/* ─── 12. Keine Tracking / Analyse ──────────────── */}
        <h2>12. Analyse- und Tracking-Tools</h2>
        <p>
          Diese Website verwendet <strong>keine</strong> Analyse- oder
          Tracking-Tools. Es werden keine Nutzungsstatistiken erhoben, keine
          Werbe-Tracker eingesetzt und keine Daten an Analyse-Dienste wie Google
          Analytics oder vergleichbare Anbieter übermittelt.
        </p>

        {/* ─── 13. Datenübermittlung in Drittländer ────────── */}
        <h2>13. Datenübermittlung in Drittländer</h2>
        <p>
          Bei der Nutzung der Google Drive-Integration und beim Abruf von
          Kartenbildern über Scryfall können Daten an Server in den USA übermittelt
          werden. Firefox, Chrome und andere Browser senden dabei Ihre IP-Adresse.
        </p>
        <p>
          Für die Google-Dienste gelten die Standardvertragsklauseln von Google.
          Scryfall ist ein öffentlich zugänglicher API-Dienst ohne
          personenbezogene Datenverarbeitung.
        </p>

        {/* ─── 14. Speicherdauer ──────────────────────────── */}
        <h2>14. Speicherdauer</h2>
        <ul>
          <li><strong>Benutzerkonto:</strong> Daten werden bis zur Löschung des Kontos gespeichert.</li>
          <li><strong>Google OAuth-Tokens:</strong> Werden bis zum Widerruf der Verknüpfung oder Löschung des Kontos gespeichert.</li>
          <li><strong>Standortdaten (PLZ, Koordinaten):</strong> Werden bis zur Löschung durch den Nutzer oder Löschung des Kontos gespeichert.</li>
          <li><strong>Admin-Audit-Log (IP-Adressen):</strong> Werden zur Sicherheitsüberprüfung gespeichert und nach 90 Tagen gelöscht.</li>
          <li><strong>localStorage-Daten:</strong> Verbleiben bis zur manuellen Löschung durch den Nutzer; Anmelde-Token und Benutzerinformationen werden zusätzlich beim Abmelden entfernt.</li>
        </ul>

        {/* ─── 15. Betroffenenrechte ──────────────────────── */}
        <h2>15. Ihre Rechte (DSGVO Art. 15–21)</h2>
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul>
          <li><strong>Auskunft</strong> über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
          <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
          <li><strong>Löschung</strong> Ihrer Daten (Art. 17 DSGVO)</li>
          <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
          <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
          <li><strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO)</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte wenden Sie sich bitte per E-Mail an den oben
          genannten Verantwortlichen.
        </p>

        {/* ─── 16. Widerruf der Einwilligung ─────────────── */}
        <h2>16. Widerruf der Einwilligung</h2>
        <p>
          Soweit die Verarbeitung auf Ihrer Einwilligung beruht (z.B. Google
          Drive-Verknüpfung oder standortbasierte Spielersuche), können Sie
          diese jederzeit mit Wirkung für die Zukunft widerrufen — bei der
          Standortsuche durch Löschen Ihrer PLZ in den Einstellungen. Die
          Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt
          davon unberührt.
        </p>

        {/* ─── 17. Beschwerderecht ────────────────────────── */}
        <h2>17. Beschwerderecht bei der Aufsichtsbehörde</h2>
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über
          die Verarbeitung Ihrer personenbezogenen Daten zu beschweren. Die für Sie
          zuständige Aufsichtsbehörde richtet sich nach Ihrem Wohnort bzw.
          Bundesland. Eine Liste der Aufsichtsbehörden finden Sie unter:{' '}
          <a
            href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.bfdi.bund.de
          </a>.
        </p>

        <div className="legal-page__disclaimer">
          <p>
            <strong>Scryfall</strong><br />
            Kartendaten und -bilder werden von{' '}
            <a href="https://scryfall.com" target="_blank" rel="noopener noreferrer">Scryfall</a>{' '}
            bereitgestellt. Diese Website ist nicht mit Scryfall affiliiert.
          </p>
          <p>
            <strong>Wizards of the Coast</strong><br />
            Magic: The Gathering ist ein eingetragenes Warenzeichen von Wizards of
            the Coast / Hasbro, Inc. Diese Seite ist inoffizieller Fan Content und
            wurde nicht von Wizards of the Coast genehmigt oder unterstützt.{' '}
            <a
              href="https://company.wizards.com/en/legal/fancontentpolicy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fan Content Policy
            </a>.
          </p>
        </div>

        <p style={{ marginTop: '24px', fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>
          Siehe auch: <Link to="/impressum">Impressum</Link>
        </p>
      </div>
    </div>
  );
}
